import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { NgLocalStorage } from 'core/utils/ng-storage.service';
import { MsalService } from 'msal';
import { AuthenticationService } from 'core/authentication.service';

@Directive({
  selector: '[appDisabledButton]'
})
export class DisabledButtonDirective implements OnInit {
  @Input() appDisabledButton;
  @Input() disabled;
  @Input() entitygroup;
  @Input() entity;
  constructor(private eleRef: ElementRef, private ngLocalStorage: NgLocalStorage, private msalService: MsalService, private _auth: AuthenticationService) { }
  disableClass() {
    this.disabled = true;
    this.eleRef.nativeElement.style.visibility = 'hidden';
  };
  enableClass() {
    this.eleRef.nativeElement.style.pointerEvents = 'auto';
    this.eleRef.nativeElement.style.cursor = 'pointer';
  };
  ngOnInit() {
    let response = JSON.parse(this.ngLocalStorage.getItem('workflowUserRoles'));
    let view = true;
    let edit = false;
    let parentInList = false;
    let roles = this._auth.getUserRoles(this.msalService);
    let enabled = false;
    let inValidRole = false;
    roles.forEach((value, key) => {
      let inValidRoleFlag = false;
      let userRolePermissions = response.filter((res) => { return res.RoleName === value });
      if (userRolePermissions.length != 0 &&
        userRolePermissions[0][this.entitygroup] !== undefined &&
        userRolePermissions[0][this.entitygroup][this.entity])
        enabled = true;

    });
    enabled ? this.enableClass() : this.disableClass();
  }
}
